export const dataModel = {
  url: "http://echoapi.velir.com",
  loadMore: false,
  perPage: 3,
  title: "Listing Title",
  loadMoreText: "Load More",
  cta: {
    href: "/learn",
    text: "View All Resources",
    target: "",
  },
  facetKeys: [],
  showFacetsLabel: "Filter Stories",
};

export const dataModelVariantFive = {
  url: "http://echoapi.velir.com",
  loadMore: false,
  perPage: 3,
  title: "Marketing books headline",
  loadMoreText: "Load More",
  cta: {
    href: "/learn",
    text: "More books",
    target: "",
  },
  facetKeys: [],
  showFacetsLabel: "Filter Stories",
};

export const dataQuery = {
  pageId: "d669a326-86bd-4394-872e-ce79a537dbbe",
  listingId: "430be22d-6e5f-46ef-afac-0ddb8dac19c2",
  showSummaries: true,
  showReadTimes: true,
  showEyebrow: true,
  showImages: true,
  variantType: 1,
};

export const mockApiResponse = {
  request: {
    pageId: "110d559f-dea5-42ea-9c1c-8a5df7e70ef9",
    page: 1,
    perPage: 3,
    sortBy: "null",
    sortOrder: "null",
    queryParameters: {
      listingId: "880c21a7-09f4-4c6a-9b19-2081002d11d0",
      showEyebrow: "true",
      showSummaries: "true",
      showReadTimes: "true",
      showImages: "true",
      variantType: 1,
    },
  },
  totalResults: 3,
  results: [
    {
      type: "page",
      key: "43a36d27-b6e2-470e-b4f1-20839b6eda3d",
      contentType: "Faculty & Research",
      title: "It's tearing up my heart when I'm with you",
      body: [],
      readTime: "Read Time: 4 min read",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
    },
    {
      type: "page",
      key: "93c34f1b-0592-4b3a-8150-86fc64f50263",
      contentType: "Publications",
      title: "I wanna dance with somebody",
      body: [],
      readTime: "Read time: 4 min read",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
    },
    {
      type: "page",
      key: "dbfd3d93-ee35-45f0-99ee-f21a568036db",
      contentType: "School News",
      title: "Can I kick it?",
      body: [],
      readTime: "Read Time: 4 min read",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
    },
  ],
  facets: [],
};

export const dataQueryNoImages = {
  pageId: "d669a326-86bd-4394-872e-ce79a537dbbe",
  listingId: "430be22d-6e5f-46ef-afac-0ddb8dac19c2",
  showSummaries: true,
  showReadTimes: true,
  showEyebrow: true,
  showImages: false,
  variantType: 1,
};

export const mockApiResponseNoImages = {
  request: {
    pageId: "110d559f-dea5-42ea-9c1c-8a5df7e70ef9",
    page: 1,
    perPage: 3,
    sortBy: "null",
    sortOrder: "null",
    queryParameters: {
      listingId: "880c21a7-09f4-4c6a-9b19-2081002d11d0",
      showEyebrow: "true",
      showSummaries: "true",
      showReadTimes: "true",
      showImages: "false",
      variantType: 1,
    },
  },
  totalResults: 3,
  results: [
    {
      type: "page",
      key: "43a36d27-b6e2-470e-b4f1-20839b6eda3d",
      contentType: "Faculty & Research",
      title: "It's tearing up my heart when I'm with you",
      body: [],
      readTime: "Read Time: 4 min read",
      displayUrl: "null",
      contentUrl: "",
    },
    {
      type: "page",
      key: "93c34f1b-0592-4b3a-8150-86fc64f50263",
      contentType: "Publications",
      title: "I wanna dance with somebody",
      body: [],
      readTime: "Read time: 4 min read",
      displayUrl: "null",
      contentUrl: "",
    },
    {
      type: "page",
      key: "dbfd3d93-ee35-45f0-99ee-f21a568036db",
      contentType: "School News",
      title: "Can I kick it?",
      body: [],
      readTime: "Read Time: 4 min read",
      displayUrl: "null",
      contentUrl: "",
    },
  ],
  facets: [],
};

export const dataQueryVariantTwo = {
  pageId: "af9379d3-a9d8-47f5-97f3-ba57838f157f",
  listingId: "f57cce14-29ae-439a-8e4c-92553345cf7c",
  showEyebrow: true,
  showImages: true,
  showReadTimes: true,
  showSummaries: true,
  variantType: 2,
};

export const mockApiResponseVariantTwo = {
  request: {
    pageId: "c8806f3b-85e7-4995-b2ec-6490010eb1d8",
    page: 1,
    perPage: 2,
    sortBy: "date",
    sortOrder: "desc",
    queryParameters: {
      topics: "Student Stories",
    },
  },
  totalResults: 2,
  results: [
    {
      type: "page",
      key: "E98F78AE-D000-4D88-986B-539FC89F3B15",
      eyebrow: "Executive MBA",
      eyebrowUrl: "/news/topics.aspx?topics=Executive%20MBA",
      title: "How an Executive MBA student fosters inclusive leadership",
      body: [],
      readTime: "6 minute read",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "Executive MBA student Rebecca Smith next to her mom.",
      quoteText: null,
      secondaryLink: null,
      secondaryLinkText: null,
    },
    {
      type: "page",
      key: "B0457044-A942-49B7-B93E-60C8B8AD5FC4",
      eyebrow: "Full-Time MBA",
      eyebrowUrl: "/news/topics.aspx?topics=Full-Time%20MBA",
      title: "Club Spotlight: The Middle East & North Africa Club",
      body: [],
      readTime: "8 minute read",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "MENA Club members during movie night",
      quoteText: null,
      secondaryLink: null,
      secondaryLinkText: null,
    },
  ],
  facets: [],
};

export const dataQueryVariantThree = {
  pageId: "af9379d3-a9d8-47f5-97f3-ba57838f157f",
  listingId: "f57cce14-29ae-439a-8e4c-92553345cf7c",
  showEyebrow: true,
  showImages: true,
  showReadTimes: true,
  showSummaries: true,
  variantType: 3,
};

export const mockApiResponseVariantThree = {
  request: {
    pageId: "af9379d3-a9d8-47f5-97f3-ba57838f157f",
    page: 1,
    perPage: 5,
    sortBy: "date",
    sortOrder: "desc",
    queryParameters: {},
  },
  totalResults: 5,
  results: [
    {
      type: "page",
      key: "DE545E05-43D0-420B-A2CC-DC663B7B5A0B",
      eyebrow: "Entrepreneurship and Innovation",
      eyebrowUrl:
        "/news/topics.aspx?topics=Entrepreneurship%20and%20Innovation",
      title:
        "Founder of mental healthcare startup shares his entrepreneurial journey, from first idea to Series C and beyond",
      body: [],
      readTime: "7 minute read",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "SonderMind CEO Mark Frank",
      quoteText: null,
      secondaryLink: null,
      secondaryLinkText: null,
    },
    {
      type: "page",
      key: "7EE58AFD-EE15-4918-B967-3282E43247AE",
      eyebrow: null,
      eyebrowUrl: null,
      title: "One 2Y’s journey to launch a social-impact startup at Kellogg",
      body: [],
      readTime: "5 minute read",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "Kellogg student Katia Tamer",
      quoteText: null,
      secondaryLink: null,
      secondaryLinkText: null,
    },
    {
      type: "page",
      key: "4C9819F1-60A9-4134-9C5A-333D9DD549E0",
      eyebrow: "Diversity Equity and Inclusion",
      eyebrowUrl:
        "/news/topics.aspx?topics=Diversity%20Equity%20and%20Inclusion",
      title:
        "Building an inclusive company culture ‘starts with each of us’ says alumnus and DEI leader",
      body: [],
      readTime: "6 minute read",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "Kellogg EMBA alum Yemi Akisanya and his daughter",
      quoteText: null,
      secondaryLink: null,
      secondaryLinkText: null,
    },
    {
      type: "page",
      key: "62ED42E1-0A6D-4CBC-A703-455443796435",
      eyebrow: "Leadership and Organizations",
      eyebrowUrl: "/news/topics.aspx?topics=Leadership%20and%20Organizations",
      title: "Podcast: Cybersecurity, Part 2 | How to Respond to a Breach",
      body: [],
      readTime: "14 min listen",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: null,
      quoteText: null,
      secondaryLink: null,
      secondaryLinkText: null,
    },
    {
      type: "page",
      key: "3E959B4E-9BBA-4452-BCB4-322678F59218",
      eyebrow: null,
      eyebrowUrl: null,
      title:
        "3 DEI Leadership Lessons from Ketanji Brown Jackson’s Supreme Court Nomination",
      body: [],
      readTime: null,
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "photo of exterior of US Supreme Court building",
      quoteText: null,
      secondaryLink: null,
      secondaryLinkText: null,
    },
  ],
  facets: [],
};

export const dataQueryVariantFive = {
  pageId: "d669a326-86bd-4394-872e-ce79a537dbbe",
  listingId: "430be22d-6e5f-46ef-afac-0ddb8dac19c2",
  showSummaries: true,
  showReadTimes: true,
  showEyebrow: true,
  showImages: true,
  variantType: 5,
};

export const mockApiResponseVariantFive = {
  request: {
    pageId: "110d559f-dea5-42ea-9c1c-8a5df7e70ef9",
    page: 1,
    perPage: 3,
    sortBy: "null",
    sortOrder: "null",
    queryParameters: {
      listingId: "880c21a7-09f4-4c6a-9b19-2081002d11d0",
      showEyebrow: "true",
      showSummaries: "true",
      showReadTimes: "true",
      showImages: "true",
      variantType: 5,
    },
  },
  totalResults: 7,
  results: [
    {
      type: "page",
      key: "43a36d27-b6e2-470e-b4f1-20839b6eda3d",
      contentType: "Faculty & Research",
      title: "A Woman's Place",
      body: [],
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ut interdum leo. Fusce vel tellus sit amet elit laoreet mattis et vel nisl.",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/179x284",
        desktop1X: "https://via.placeholder.com/179x284",
        mobile2X: "https://via.placeholder.com/358x568",
        desktop2X: "https://via.placeholder.com/358x568",
      },
      imageAlt: "alt",
    },
    {
      type: "page",
      key: "93c34f1b-0592-4b3a-8150-86fc64f50263",
      contentType: "Publications",
      title: "Building a Successful Family Business Board",
      body: [],
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ut interdum leo. Fusce vel tellus sit amet elit laoreet mattis vel nisl.",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/186x284",
        desktop1X: "https://via.placeholder.com/186x284",
        mobile2X: "https://via.placeholder.com/372x568",
        desktop2X: "https://via.placeholder.com/372x568",
      },
      imageAlt: "alt",
    },
    {
      type: "page",
      key: "dbfd3d93-ee35-45f0-99ee-f21a568036db",
      contentType: "School News",
      title: "Keeping the Family Business Healthy",
      body: [],
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ut interdum leo. Fusce vel tellus sit amet elit laoreet mattis vel nisl.",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/342x260",
        desktop1X: "https://via.placeholder.com/342x260",
        mobile2X: "https://via.placeholder.com/684x520",
        desktop2X: "https://via.placeholder.com/684x520",
      },
      imageAlt: "alt",
    },
    {
      type: "page",
      key: "dbfd3d93-ee35-45f0-99ee-f21a568036db",
      contentType: "School News",
      title: "Example of a portrait image that is larger",
      body: [],
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ut interdum leo. Fusce vel tellus sit amet elit laoreet mattis vel nisl.",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/744x1136",
        desktop1X: "https://via.placeholder.com/744x1136",
        mobile2X: "https://via.placeholder.com/1488x2272",
        desktop2X: "https://via.placeholder.com/1488x2272",
      },
      imageAlt: "alt",
    },
    {
      type: "page",
      key: "dbfd3d93-ee35-45f0-99ee-f21a568036db",
      contentType: "School News",
      title: "Example of a landscape image that is larger",
      body: [],
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ut interdum leo. Fusce vel tellus sit amet elit laoreet mattis vel nisl.",
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/1368x1040",
        desktop1X: "https://via.placeholder.com/1368x1040",
        mobile2X: "https://via.placeholder.com/2736x2080",
        desktop2X: "https://via.placeholder.com/2736x2080",
      },
      imageAlt: "alt",
    },
  ],
  facets: [],
};
